import { render } from "./Month.vue?vue&type=template&id=6684f72b"
import script from "./Month.vue?vue&type=script&lang=ts"
export * from "./Month.vue?vue&type=script&lang=ts"
script.render = render

export default script